import { createContext } from "react";

import { IContextMenuController } from "@amphore-dev/amphore-lib";

import { TView, TProject, TTask } from "@/types";

/**
 * views-list menu also opens from TasksListHeader's "..." button (for
 * the active view, from the list header) — `from`/`onSelect`
 * carry the extra bits that path needs (matches an item's `hidden` check
 * and the "select multiple" action) that a plain right-click never sets.
 */
export type TViewCtxMenuData = TView & {
	from?: "taskList";
	onSelect?: () => void;
};

export interface IContextMenusContext {
	views: IContextMenuController<TViewCtxMenuData>;
	projects: IContextMenuController<TProject>;
	tasksList: IContextMenuController<TTask>;
}

export const ContextMenusContext = createContext<IContextMenusContext | null>(
	null
);
